import React from 'react';
import PropTypes from 'prop-types';
import classes from './checkoutCardTable.module.scss';
import Checkbox from '../../../../../_common/Form/Checkbox/Checkbox';
import { CardIcon } from '../../../../../../utils/data/data';

const CheckoutCardTable = ({
  checkoutData, checkedIds, setCheckedIds,
}) => {
  const checkAmount = (id) => {
    if (id === checkedIds) {
      setCheckedIds('');
    } else {
      setCheckedIds(id);
    }
  };
  return (
    <div className={classes.table}>
      {checkoutData.map((p) => (
        <div key={p.customerPaymentProfileId} className={classes.cards}>
          <span>
            <Checkbox
              onChange={() => checkAmount(p.customerPaymentProfileId)}
              checked={checkedIds === p.customerPaymentProfileId}
            />
          </span>

          <span onClick={() => checkAmount(p.customerPaymentProfileId)}>{CardIcon[p.payment.creditCard.cardType]}</span>

          <span onClick={() => checkAmount(p.customerPaymentProfileId)}>{p.payment.creditCard.cardNumber}</span>

        </div>
      ))}
    </div>
  );
};

CheckoutCardTable.propTypes = {
  checkoutData: PropTypes.array.isRequired,
  checkedIds: PropTypes.string.isRequired,
  setCheckedIds: PropTypes.func.isRequired,
};

export default CheckoutCardTable;
